import { useParams } from "react-router-dom";
import EventLeftDetails from "./components/EventLeftDetails";
import EventRightDetails from "./components/EventRightDetails";
import httpServices from "../../../services/httpServices";
import { useEffect, useState } from "react";
import { useUser } from "../../../context/UserContext";

const SignleEventDetails = () => {
  const { title, id } = useParams() || "";
  const [eventData, setEventData] = useState();

  const getEventDetails = async () => {
    try {
      const { response, error } = await httpServices.get(
        `/event/details/${id}`,
        {
          skip: !id,
        }
      );

      if (error) {
        throw error;
      }
      if (response.status === 200) {
        console.log("Response from getEventDetails", response.data);
        setEventData(response.data?.data);
      }
    } catch (error) {
      console.log("Error", error);
    }
  };

  useEffect(() => {
    getEventDetails();
  }, [id]);

  return (
    <div className="w-full min-h-[1169px] !p-[10px] xs:p-[16px] bg-white rounded-[10px] my-[16px] gap-[16px] flex lg:!flex-nowrap flex-wrap">
      <EventLeftDetails data={eventData} />
      <EventRightDetails data={eventData} />
    </div>
  );
};

export default SignleEventDetails;
